import { defineMessages } from 'react-intl';

export default defineMessages({
  placeholder_inHours: {
    id: 'kustomer.chat.conversation.input.placeholder.inHours',
    description: 'Placeholder for in hours',
    defaultMessage: 'Type a message...',
  },
  placeholder_afterHours: {
    id: 'kustomer.chat.conversation.input.placeholder.afterHours',
    description: 'Placeholder for after hours',
    defaultMessage: 'Leave a message...',
  },
  input_disabled: {
    id: 'kustomer.chat.conversation.input.disabled.copy',
    description: 'Copy when chat input is disabled',
    defaultMessage: "Thank You! We'll follow up on your request.",
  },
  upload_fail_fileSize: {
    id: 'kustomer.chat.conversation.input.error.fileSize',
    description: 'Error copy for failed upload due to file size',
    defaultMessage: 'Please upload a file less than 10mb',
  },
  upload_fail_fileType: {
    id: 'kustomer.chat.conversation.input.error.fileType',
    description: 'Error copy for failed upload due to file type',
    defaultMessage: 'Only images and PDFs are allowed uploads',
  },
  message_body_attachment: {
    id: 'kustomer.chat.conversation.input.attachment.body',
    description: 'Message body for uploads',
    defaultMessage: 'File attached',
  },
  message_body_attachment_failed: {
    id: 'kustomer.chat.conversation.input.attachment.error.failed',
    description: 'Message body for failed upload',
    defaultMessage: 'Attachment upload failed',
  },
});
